import { Button } from "@design-system/Button/Button";
import { useViewOnlyRefusal } from "@hooks/permissions/useViewOnlyRefusal";
import { useOverlays } from "contexts/OverlayContext";

// eslint-disable-next-line react-refresh/only-export-components
export const INVOICE_CREATE_CTA_TITLE = "Create an invoice to get started";
// eslint-disable-next-line react-refresh/only-export-components
export const INVOICE_CONNECT_CTA_SUBTITLE =
    "Create, manage, and track all your invoices in one place.";

export const InvoiceConnectButtons: React.FC = () => {
    const { openOverlay } = useOverlays();
    const { refuseIfViewOnly } = useViewOnlyRefusal();

    return (
        <Button
            variant="primary"
            size="md"
            onClick={() => {
                // The drawer's save is the first thing the server sees, by
                // which point the invoice has been filled in.
                if (refuseIfViewOnly()) {
                    return;
                }
                openOverlay("nativeInvoiceDrawer", {});
            }}
        >
            Create invoice
        </Button>
    );
};
